import React, { Component } from 'react';
import { pluck } from 'underscore';
import { BaseContextItem } from './user_context_item';
import pluralize from 'pluralize';

// anonymous context info
export const AnonContext = ({
  user_location,
  department,
  user_occupation,
  interests,
}) => {
  return (
    <div className="wp-usercard-context responsive_margins truncate">
      <BaseContextItem icon="university">
        {department && department.university && department.university.name}
      </BaseContextItem>

      <BaseContextItem icon="graduation-cap">
        {department && department.name}
      </BaseContextItem>

      <BaseContextItem icon="briefcase">
        {!department && user_occupation && user_occupation.name}
      </BaseContextItem>

      <BaseContextItem icon="map-marker">
        {user_location &&
          (user_location.city || user_location.country) &&
          [user_location.city, user_location.country]
            .filter(Boolean)
            .join(', ')}
      </BaseContextItem>

      <BaseContextItem icon="tag" capitalize>
        {interests && interests.length && pluck(interests, 'name').join(', ')}
      </BaseContextItem>
    </div>
  );
};

// user context info with research interests popup
export class UserContext extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      user_location,
      department,
      position,
      user_occupation,
      percentile,
      interests,
      all_time_view_counts,
      followers_count,
    } = this.props;

    const totalViews = all_time_view_counts
      ? all_time_view_counts.documents_count +
        all_time_view_counts.non_documents_count
      : null;

    return (
      <div className="wp-usercard-context responsive_margins truncate">
        <BaseContextItem icon="university">
          {department && department.university && department.university.name}
        </BaseContextItem>

        <BaseContextItem icon="graduation-cap">
          {department && department.name}
        </BaseContextItem>

        <BaseContextItem icon="briefcase">{position}</BaseContextItem>

        <BaseContextItem icon="briefcase">
          {!department && user_occupation && user_occupation.name}
        </BaseContextItem>

        <BaseContextItem icon="map-marker">
          {user_location &&
            (user_location.city || user_location.country) &&
            [user_location.city, user_location.country]
              .filter(Boolean)
              .join(', ')}
        </BaseContextItem>

        <BaseContextItem icon="trophy" capitalize>
          {percentile}
        </BaseContextItem>

        <div>
          <BaseContextItem icon="tag" capitalize>
            {interests &&
              !!interests.length &&
              (interests.length > 1
                ? `${interests[0].name} + ${interests.length - 1}`
                : interests[0].name)}
          </BaseContextItem>
        </div>

        <BaseContextItem
          icon="eye"
          units={'total ' + pluralize('view', totalViews)}
        >
          {totalViews && totalViews.toLocaleString()}
        </BaseContextItem>

        <BaseContextItem
          icon="group"
          units={pluralize('follower', followers_count)}
        >
          {followers_count && followers_count.toLocaleString()}
        </BaseContextItem>
      </div>
    );
  }
}
